// extracted by mini-css-extract-plugin
export var layout = "PageGrid-module--layout--SHRXT";
export var section = "PageGrid-module--section---yVxw";
export var fullWidth = "PageGrid-module--fullWidth--2QQbK";
export var component = "PageGrid-module--component--9iwro";
export var item = "PageGrid-module--item--fo3Za";
export var group = "PageGrid-module--group--ZhXbd";